import {User} from '@/types/user'

const COMPANY_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

const uniqueValues = (values: Array<string | null | undefined>) => (
    [...new Set(values.filter((value): value is string => Boolean(value)))]
)

const getUserCompanyIds = (user: User): string[] => {
    const metadataCompanyIds = uniqueValues(user.metadata?.companyIds || [])
        .filter(companyId => COMPANY_ID_PATTERN.test(companyId))

    if (metadataCompanyIds.length > 0) {
        return metadataCompanyIds
    }

    return uniqueValues([
        ...(user.company_ids || []),
        ...(user.companies || []).map(company => (
            typeof company === 'string' ? company : company.id
        )),
        user.company_id,
    ])
}

export default getUserCompanyIds

